"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'indexHotEstimatedDays',
  methods: {
    validateNull: _validate.validateNull,
    getDiffDay: function getDiffDay(new_date, old_date) {
      //当datestring=2017-02-16时，解析的结果为：Thu Feb 16 2017 08:00:00 GMT+0800 (中国标准时间)多了八个小时
      var newDate = new_date.replace('-', '/');
      var oldDate = old_date.replace('-', '/');
      var myDate_1 = new Date(newDate);
      var myDate_2 = new Date(oldDate);
      var subtime = (myDate_1 - myDate_2) / 1000; //计算时间差,并将毫秒转化为秒
      var days = parseInt(subtime / 86400); //天  24*60*60*1000
      return this.isInteger(days + (subtime / 3600 - 24 * days) / 24) ? days + (subtime / 3600 - 24 * days) / 24 : (days + (subtime / 3600 - 24 * days) / 24).toFixed(1); //天
    },
    isInteger: function isInteger(n) {
      return parseInt(n) === parseFloat(n);
    }
  }
};